import { z } from 'zod';

import type { Nullable } from '@clearverify/types';

export const getEmailDomainForSearch = (searchValue: string): Nullable<string> => {
  if (searchValue.includes('@')) {
    const { success, data: emailAddress } = z.email().trim().safeParse(searchValue);
    if (success) {
      return emailAddress.split('@')[1];
    }
  }

  const { success, data: staffDomain } = z
    .string()
    .trim()
    .regex(z.regexes.domain)
    .safeParse(searchValue);
  if (success) {
    return staffDomain;
  }

  return null;
};
